const STORAGE_KEY = "iron_attribution";

export type Attribution = {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
  gclid?: string;
  fbclid?: string;
  referrer?: string;
  landing_page?: string;
  captured_at?: string;
};

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
  "gclid",
  "fbclid",
] as const;

export function captureAttribution(): void {
  if (typeof window === "undefined") return;
  try {
    const existing = window.localStorage.getItem(STORAGE_KEY);
    if (existing) return; // first-touch — do not overwrite

    const params = new URLSearchParams(window.location.search);
    const data: Attribution = {};
    let hasAny = false;
    for (const key of UTM_KEYS) {
      const v = params.get(key);
      if (v) {
        data[key] = v.slice(0, 255);
        hasAny = true;
      }
    }

    // Always capture referrer + landing page (useful even without UTMs)
    if (document.referrer) data.referrer = document.referrer.slice(0, 500);
    data.landing_page = window.location.href.slice(0, 500);
    data.captured_at = new Date().toISOString();

    if (hasAny || data.referrer) {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    }
  } catch {
    // ignore (private mode, quota, etc.)
  }
}

export function getAttribution(): Attribution {
  if (typeof window === "undefined") return {};
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return JSON.parse(raw) as Attribution;
  } catch {
    return {};
  }
}
